module.exports = __webpack_public_path__ + "static/media/ezgif.com-gif-maker (3).cb4a5971.gif";